// extracted by mini-css-extract-plugin
export default {"weekend":"orderForm_weekend__GbR9d"};